import cn from 'classnames';

import { Flag } from 'ui/atoms/Flag/Flag';
import { InfiniteScroller } from 'ui/molecules/InfiniteScroller/InfiniteScroller';

import styles from './PricingRegistries.module.scss';

const REGISTRIES = [
  { iso: 'gb', country: 'United Kingdom', registry: 'Companies House' },
  { iso: 'ie', country: 'Ireland', registry: 'Companies Registration Office' },
  { iso: 'us', country: 'United States', registry: '50 Secretary of State registries' },
  { iso: 'sg', country: 'Singapore', registry: 'ACRA' },
  { iso: 'it', country: 'Italy', registry: 'Registro delle Imprese' },
  { iso: 'de', country: 'Germany', registry: 'Handelsregister' },
  { iso: 'fr', country: 'France', registry: 'Registre du Commerce et des Sociétés' },
  { iso: 'nl', country: 'Netherlands', registry: 'KVK Handelsregister' },
  { iso: 'es', country: 'Spain', registry: 'Registro Mercantil' },
  { iso: 'be', country: 'Belgium', registry: 'Kruispuntbank van Ondernemingen' },
  { iso: 'ch', country: 'Switzerland', registry: 'Zefix' },
  { iso: 'at', country: 'Austria', registry: 'Firmenbuch' },
  { iso: 'dk', country: 'Denmark', registry: 'CVR' },
  { iso: 'se', country: 'Sweden', registry: 'Bolagsverket' },
  { iso: 'no', country: 'Norway', registry: 'Brønnøysundregistrene' },
  { iso: 'fi', country: 'Finland', registry: 'Finnish Patent and Registration Office' },
  { iso: 'pl', country: 'Poland', registry: 'Krajowy Rejestr Sądowy' },
  { iso: 'pt', country: 'Portugal', registry: 'Registo Comercial' },
  { iso: 'lu', country: 'Luxembourg', registry: 'RCS Luxembourg' },
  { iso: 'hk', country: 'Hong Kong', registry: 'Companies Registry' },
  { iso: 'au', country: 'Australia', registry: 'ASIC' },
  { iso: 'nz', country: 'New Zealand', registry: 'Companies Office' },
  { iso: 'ca', country: 'Canada', registry: 'Corporations Canada' },
  { iso: 'in', country: 'India', registry: 'Ministry of Corporate Affairs' },
  { iso: 'ae', country: 'UAE', registry: 'Department of Economy and Tourism' },
  { iso: 'za', country: 'South Africa', registry: 'CIPC' },
  { iso: 'mx', country: 'Mexico', registry: 'Registro Público de Comercio' },
  { iso: 'hu', country: 'Hungary', registry: 'Cégjegyzék' },
];

const registryItems = REGISTRIES.map(({ iso, country, registry }) => (
  <div className={styles.slide} key={iso}>
    <div className={styles.card}>
      <Flag code={iso} className={styles.flag} />

      <span className={styles.text}>
        <span className={styles.country}>{country}</span>
        <span className={styles.name}>{registry}</span>
      </span>
    </div>
  </div>
));

interface Props {
  className?: string;
}

export const PricingRegistries = ({ className }: Props) => (
  <div className={cn(styles.registries, className)} aria-label="Government registries Global Database sources from">
    <div className={styles.inner}>
      <span className={styles.label}>Sourced directly from the registers that issue the record</span>
    </div>

    <InfiniteScroller
      items={registryItems}
      slideWidth={236}
      slideGap={24}
      animationDuration={65}
      backgroundColor="#f9f9f9"
    />
  </div>
);
